import * as React from 'react';
import { Textarea, HiddenInput, Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, Form, } from "soprasteria-ui-library";
import { IReferralAssessmentRejectForm } from '../../../../models/IReferral';

interface IReferralAssessmentRejectModal {
    referralTreatmentId?: number;
    onSubmit: (referralTreatmentId: number, comment: string) => void
    onFormClose: () => void;
}

export const ReferralAssessmentRejectModal: React.FunctionComponent<IReferralAssessmentRejectModal> = ({ referralTreatmentId, onSubmit, onFormClose }) => {

    const onFormSubmit = (formData: IReferralAssessmentRejectForm) => {
        document.getElementById("close-referral-assessment-reject-treatment-modal")?.click();
        onSubmit(formData.referralTreatmentId, formData.comment);
    }

    return (
        <Modal header="Avvisa åtgärd" modalSize={ModalSize.large} id="referral-assessment-reject-treatment-modal">
            {
                referralTreatmentId ?
                    <Form onSubmit={onFormSubmit}>
                        <ModalBody>
                            <HiddenInput name="referralTreatmentId" value={referralTreatmentId.toString()} />
                            <Textarea name="comment" label="Anledning" rows={5} inlineLabel required maxLength={200} />
                        </ModalBody>
                        <ModalFooter>
                            <CustomButton id="close-referral-assessment-reject-treatment-modal" buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" onClick={() => onFormClose()}/>
                            <CustomSubmitButton>Avvisa</CustomSubmitButton>
                        </ModalFooter>
                    </Form>
                    : null
            }
        </Modal>
    )
}